import {observer} from 'mobx-react';
import {autoinject, bind, inject, Modal, ModalHandle, NotificationList, Tooltip, Topbar} from 'Mri.Web.Common';
import * as React from 'react';
import {AccountStore, IUserGridColumnPreset, NO_ACTIVE_PRESET} from '../Account/AccountStore';
import {AppStore} from './AppStore';
import {UserMenu} from './UserMenu';
import {action, computed} from "mobx";
import {BsRepeat, BsXCircle, BsLock, BsUnlock} from "react-icons/bs";

export interface IHeaderProps {
    readonly onMenuLinkClick: any;
    readonly history: any; // Hack to get component to rerender on location change
}

@autoinject
@observer
export class Header extends React.Component<IHeaderProps> {
    public render() {
        return (
            <Topbar onMenuLinkClick={this.props.onMenuLinkClick} hide={this.appStore.hiddenHeader}>
                <div className="py-0 ms-auto d-flex">
                    {this.accountStore.storage.displaysPreference == 'list' &&
                        <div className="d-none d-md-flex" style={{ minWidth: 250 + "px" }}>
                            {this.accountStore.storage.activeColumnPreset && (
                                <div>
                                    Columns: <strong>{this.accountStore.storage.activeColumnPreset}</strong>
                                </div>
                            )}
                            {this.accountStore.storage.activeStickyPreset && (
                                <div>
                                    Stickies: <strong>{this.accountStore.storage.activeStickyPreset}</strong>
                                </div>
                            )}
                        </div>
                    }

                    {this.accountStore.storage.displaysPreference == 'grid' &&
                        <div className="d-none d-md-flex align-items-center" style={{ minWidth: 250 + "px" }}>
                            {this.gridColumnPreset && (
                                <div>
                                    Active Preset: <strong>{this.gridColumnPreset}</strong>
                                    {!this.accountStore.storage.gridAutoUpdatePresets &&
                                        <Tooltip message="Overwrite" className="p-0">
                                            <a className="btn btn-link px-1"
                                               onClick={(e) => {
                                                   e.stopPropagation();
                                                   this.overwritePreset();
                                               }}
                                            >
                                                <BsRepeat className="text-orange f-14"/>
                                            </a>
                                        </Tooltip>
                                    }
                                   
                                    
                                    <button onClick={() => this.unsetPreset()} className="btn btn-link d-inline-block">
                                        <BsXCircle className="text-danger" />
                                    </button>
                                </div>
                            )}
                        </div>
                    }
                    
                    <NotificationList />
                    {this.appStore.isTouchDevice && this.appStore.gridRef && (
                        <Tooltip message={this.accountStore.storage.gridMobileColumnMoveLocked ? "Column movement locked" : "Column movement unlocked"}>
                            <button
                                onClick={this.toggleColumnMoveLock}
                                className="btn btn-link"
                                style={{ fontSize: 20 }}
                            >
                                {this.accountStore.storage.gridMobileColumnMoveLocked ? (
                                    <BsLock className="text-orange" />
                                ) : (
                                    <BsUnlock />
                                )}
                            </button>
                        </Tooltip>
                    )}
                    <UserMenu />
                    <Modal
                        className="modal-sm"
                        title="Confirm Overwrite"
                        modalHandle={this.confirmOverwriteModalHandle}
                        btnClass="w-50"
                        footerClass="d-flex justify-content-center"
                    >
                        <div className="text-center">Overwrite Preset?</div>
                    </Modal>
                </div>
            </Topbar>
        );
    }
    
    @bind
    @action
    private unsetPreset() {
        let columns = this.appStore.gridRef?.api.getColumnState();
        if(columns){
            this.accountStore.storage.noActivePresetGridColumns = columns;
        }
        
        this.accountStore.tabStorage.activeGridColumnPreset = NO_ACTIVE_PRESET;
        this.accountStore.storage.activeGridColumnPreset = NO_ACTIVE_PRESET;
    }

    @bind
    @action
    private async overwritePreset() {
        if (await this.confirmOverwriteModalHandle.confirm()) {
            let preset = this.accountStore.storage.gridColumnPresets.find(p => p.name == this.accountStore.storage.activeGridColumnPreset);
            if(preset != undefined){
                // Remove the existing preset with the same name
                this.accountStore.storage.gridColumnPresets = this.accountStore.storage.gridColumnPresets.filter(
                    (p: IUserGridColumnPreset) => p.name !== preset?.name
                );

                // Update the columns
                preset.columns = this.accountStore.tabStorage.activeGridColumns;

                // Add the updated preset to the beginning of the array
                this.accountStore.storage.gridColumnPresets.unshift(preset);

                // Set the active preset name
                this.accountStore.tabStorage.activeGridColumnPreset = preset.name;
            }
        }
    }
    
    @computed
    private get gridColumnPreset(){
        let gridColumnPresets = this.accountStore.storage.gridColumnPresets || []
        let preset = this.accountStore.tabStorage.activeGridColumnPreset;
        let activePreset = gridColumnPresets.find(p => p.name == preset);
        return activePreset?.name || '';
    }

    @bind
    @action
    private toggleColumnMoveLock() {
        this.accountStore.storage.gridMobileColumnMoveLocked = !this.accountStore.storage.gridMobileColumnMoveLocked;

        // Refresh the grid to apply the new setting
        this.appStore.gridInitialized = false;
        this.appStore.gridKey = 0;
    }

    @inject
    private appStore!: AppStore;
    @inject
    private accountStore!: AccountStore;
    private confirmOverwriteModalHandle = new ModalHandle();
}
